import { type Infer, nullable, object, string } from "superstruct";

import { deserializeIsoDate, isoDate, serializeIsoDate } from "../scalar_types/isoDate.js";
import Party, { PartyInfosSerializedSchema } from "./Party.js";

export const ContactSerializedSchema = object({
    id: nullable(string()),
    projetId: nullable(string()),
    infos: PartyInfosSerializedSchema,
    createdAt: nullable(isoDate),
});

export type ContactSerialized = Infer<typeof ContactSerializedSchema>;

export default class Contact extends Party {
    projet: string | null = null;

    serialize(): ContactSerialized {
        return {
            id: this.id,
            projetId: this.projet,
            infos: this.serializeInfos(),
            createdAt: serializeIsoDate(this.createdAt),
        };
    }

    static deserialize(data: ContactSerialized): Contact {
        const contact = new Contact();
        contact.id = data.id;
        contact.projet = data.projetId;
        contact.createdAt = deserializeIsoDate(data.createdAt);
        contact.loadInfos(data.infos);
        return contact;
    }
}
